// extracted by mini-css-extract-plugin
export default {"serverError":"SV7dxpe6hIMjMMaH4qG5","forgotPassword":"NJBmjZwxyi5KuMRA_UHo"};